import Link from 'next/link';

import LogoTitle from '@/entites/logo/ui/LogoTitle';
import { LOGO_SIZES } from '@/shared/model/constants/home-page';
import LogoImage from '@/shared/ui/logo/LogoImage';

interface LogoProps {
  theme: 'default' | 'white';
}

const Logo = ({ theme }: LogoProps) => (
  <Link href="/" className="flex items-center gap-[10px]">
    <LogoImage theme={theme} width={LOGO_SIZES.width} height={LOGO_SIZES.height} />
    <div className="w-[1px] h-[14px] bg-secondary-grey" />
    <LogoTitle theme={theme} />
  </Link>
);

export default Logo;
